module.exports = __webpack_public_path__ + "img/canada.3b1b6695.svg";